import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {motion, useAnimation} from 'framer-motion';

export const AnimateOnScroll = ({children, delay=0}) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  return (
    <div ref={ref}>
      <motion.div
        initial="hidden"
        animate={controls}
        variants={{
          visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay } },
          hidden: { opacity: 0, y: 40 }
        }}
      >
        {children}
      </motion.div>
    </div>
  );
};
